
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comprar-boletos/[movie]/[session]",
      function () {
        return require("private-next-pages/comprar-boletos/[movie]/[session].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comprar-boletos/[movie]/[session]"])
      });
    }
  